import React from "react";
import { Button } from "antd";
import {
  UserOutlined,
  GlobalOutlined,
  TrophyOutlined,
  HomeOutlined,
  ShoppingCartOutlined,
  MedicineBoxOutlined,
  PlayCircleOutlined,
  CloudOutlined,
  HeartOutlined,
  FireOutlined,
  ThunderboltOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import {
  PACKAGE_QUICK_CATEGORY_ITEMS,
  filterVisiblePackageQuickCategories,
} from "../../../../constants/packageQuickCategoryItems";

const ICON_BY_KEY = {
  "ADULTS ONLY": UserOutlined,
  Attractions: ThunderboltOutlined,
  Cruise: GlobalOutlined,
  Football: TrophyOutlined,
  "HOTEL AND TOUR": HomeOutlined,
  Kosher: HeartOutlined,
  MASSORET: HeartOutlined,
  Russian: GlobalOutlined,
  "SHOP AND STORE": ShoppingCartOutlined,
  "SKI KOSHER": CloudOutlined,
  "SPA MEDICAL": MedicineBoxOutlined,
  SHOW: PlayCircleOutlined,
  Ski: CloudOutlined,
  Spa: HeartOutlined,
  Sport: FireOutlined,
  "Water Park": ThunderboltOutlined,
  fashionTour: ShopOutlined,
};

/**
 * רשת כפתורי קטגוריות — עיצוב זהה ל-QuickSearchBlock לשעבר (QuickSearchBlock.css).
 */
export default function PackageQuickCategoryGrid({
  subjectsFlightsHotel,
  selectedKey,
  loadingKey,
  onCategoryClick,
  showHeader = true,
  headerLabel = "חיפוש מהיר",
}) {
  const visible = filterVisiblePackageQuickCategories(
    subjectsFlightsHotel,
    PACKAGE_QUICK_CATEGORY_ITEMS
  );

  if (visible.length === 0) return null;

  return (
    <div className="quick-search-block-wrapper">
      {showHeader ? (
        <div className="quick-search-header-modern">
          <div className="quick-search-header-content">
            <span className="quick-search-indicator" aria-hidden />
            <span className="quick-search-label-modern">{headerLabel}</span>
          </div>
        </div>
      ) : null}
      <div className="quick-search-grid-modern">
        {visible.map((category) => {
          const Icon = ICON_BY_KEY[category.key] || GlobalOutlined;
          const isLoading = loadingKey === category.key;
          const isSelected = selectedKey === category.key;
          return (
            <Button
              key={category.key}
              type={isSelected ? "primary" : "default"}
              size="small"
              icon={!isLoading ? <Icon /> : undefined}
              iconPosition="start"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onCategoryClick(category);
              }}
              loading={isLoading}
              disabled={loadingKey !== null && !isLoading}
              className={`quick-search-category-button-modern ${
                isSelected ? "selected" : ""
              }`}
            >
              {category.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
